import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit'
import {
  organizationSettingType,
  getEmptyOrganizationSetting,
} from 'pages/CustomizeScoreboard/model/organizationSetting'

const initialState: organizationSettingType = getEmptyOrganizationSetting()

const organization_setting = createSlice({
  name: 'organization_setting',
  initialState,
  reducers: {
    setOrganizationInformation(state, { payload }: PayloadAction<organizationSettingType>) {
      state.organization_information = payload.organization_information
    },
  },
})

export const getOrganizationSettings = createAction('setting/getOrganizationSettings')
export const { setOrganizationInformation } = organization_setting.actions

export default organization_setting.reducer
